__turbopack_context__.v({
  "background": "x6lEuq_background",
  "copyBlock": "x6lEuq_copyBlock",
  "heroMediaArea": "x6lEuq_heroMediaArea",
  "heroPoster": "x6lEuq_heroPoster",
  "heroSignalBand": "x6lEuq_heroSignalBand",
  "heroVideo": "x6lEuq_heroVideo",
  "location": "x6lEuq_location",
  "mediaFrame": "x6lEuq_mediaFrame",
  "overlay": "x6lEuq_overlay",
  "section": "x6lEuq_section",
  "subtitle": "x6lEuq_subtitle",
  "title": "x6lEuq_title",
  "titleWrap": "x6lEuq_titleWrap",
});
